import React from "react";

export const OutLineButton = ({ label, onClick, style }) => {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "10px 30px",
        backgroundColor: "transparent",
        border: "2px solid white",
        color: "#ffffff",
        fontSize: "16px",
        borderRadius: "50px",
        cursor: "pointer",
        transition: "background-color 0.3s ease", 
        ...style,
      }}
    >
      {label}
    </button>
  );
};